import React, { Component } from 'react';
import axios from 'axios';
import { config } from '../../Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../Asset/Css/Site.css';
import Select from 'react-select';
import global from '../global';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import EasyDebenturesLogo from '../../Asset/Images/easy-dividend-logo.png';
import Spinner from '../Spinner';
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import queryString from 'query-string';
import moment, { now } from 'moment';
import DebenturesHubLogo from '../../Asset/Images/Debentures-Hub-logo.svg';
import NexdmsmImg from '../../Asset/Images/nexdigm-logo-sm.png';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const ResidentType = [
    { value: "Resident", label: "Resident" },
    { value: "Non-Resident", label: "Non-Resident" },
];

export class OfflineResident extends Component {
    constructor(props) {
        super(props);
        this.state = {
            residentialStatus: '',
            ResidentType: [],
            BeneficiaryName: '',
            PAN: '',
            EmailId: '',
            currentDate: moment().format("YYYY-MM-DD"),
            dob: '',
            companyList: [],
            RemitterID: '',
            isSearchable: true,
            RemitterName: '',
            isBASF: 'none',
            AssignmentList: [],
            AssignmentCode: '',
            loading: false,
            formErrors: '',
            DPID: '',
            IsOnlineOffline: 0,
            IsSaveDisable: false,
            NR: '',
            ShowDataPrivacy: '',
            isOfflineNR: '',
            IPaddress: ''
        };

        this.initialState = this.state;
        global.IpAddress = localStorage.getItem('IPaddress');
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage

        this.HandleRemitter();
        this.setState({ loading: false });
        this.handleCompany = this.handleCompany.bind(this);
        this.handleAssignment = this.handleAssignment.bind(this);

        const parsed = queryString.parse(window.location.search);

        this.state.DPID = parsed['DP'] == undefined ? 0 : window.atob(parsed['DP']);
        this.state.PAN = parsed['PN'] == undefined ? 0 : window.atob(parsed['PN']);
        this.state.AssignmentCode = parsed['AC'] == undefined ? 0 : window.atob(parsed['AC']);
        this.state.NR = parsed['NR'] == undefined ? 0 : window.atob(parsed['NR']);

        this.setState({ IsSaveDisable: true });

    }
    HandleRemitter() {
        console.log("Hi");
        axios.get(global.OfflineResident.GetcompanyListDDLAPI)
            .then(response => {
                if (response.data.status) {
                    console.log(response.data.status);
                    const optionsCompany = response.data.RemitterList.map(d => ({
                        "value": d.ID,
                        "label": d.Label
                    }))
                    this.setState({
                        companyList: optionsCompany
                    })
                }
                else {

                }
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    handleCompany(e) {
        this.state.AssignmentCode = '';
        if (e.label == "BASF INDIA LIMITED") {
            this.setState({
                RemitterID: e.value,
                RemitterName: e.label,
                isBASF: 'block'
            });
        }
        else {
            this.setState({
                RemitterID: e.value,
                isBASF: 'none'
            });

            axios.get(global.OfflineResident.GetAssignmentCodeAPI + '?RemitterID=' + e.value)
                .then(response => {
                    if (response.data.status) {
                        const optionAssignmentCode = response.data.AssignmentCodeList.map(d => ({
                            "value": d.ID,
                            "label": d.Label
                        }))
                        this.setState({
                            AssignmentList: optionAssignmentCode
                        })
                    }
                    else {

                    }
                })
                .catch(error => {
                    this.setState({ loading: false });
                });
        }
    }

    handleAssignment = (e) => {
        console.log(Array.isArray(e) ? e.map(x => x.value) : []);

        let Assignment = Array.isArray(e) ? e.map(x => x.value) : []
        this.state.AssignmentCode = Assignment.join(',');
    };

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;

        if ([name] == "PAN") {
            this.setState({
                [name]: value.toUpperCase()
            });
        }
        else {
            this.setState({ [name]: value });
        }
    }

    handleFormValidation = (e) => {
        const { BeneficiaryName, dob, residentialStatus, RemitterID, AssignmentCode, EmailId } = this.state;

        let formErrors = {};
        let formIsValid = true;


        //Beneficiary Name
        if (!BeneficiaryName) {
            formIsValid = false;
            formErrors["BeneficiaryErr"] = "Beneficiary Name is required.";
        }

        //DOB    
        //if (!dob) {
        //    formIsValid = false;
        //    formErrors["DOBErr"] = "Date of Birth is required.";
        //}

        //ResidentType
        if (!residentialStatus) {
            formIsValid = false;
            formErrors["ResidentTypeErr"] = "Resident Type is required.";
        }

        //CompnayType
        if (!RemitterID) {
            formIsValid = false;
            formErrors["companyErr"] = "Select company is required.";
        }

        //Assignment Code
        if (!AssignmentCode) {
            formIsValid = false;
            formErrors["AssignmentErr"] = "Select Assignment Name is required.";
        }


        //Email    
        if (!EmailId) {
            formIsValid = false;
            formErrors["EmailIdErr"] = "Email id is required.";
        }
        else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(EmailId))) {

            formIsValid = false;
            formErrors["EmailIdErr"] = "Invalid email id.";
        }

        const { name, value } = e.target;
        console.log(EmailId);
        this.setState({ [name]: value });
        this.setState({ formErrors: formErrors });

        return formIsValid;

    }

    handleResidentType(e) {
        if (e.value != undefined) {
            this.setState({ residentialStatus: e.label });
            if (e.label === 'Non-Resident') {
                this.setState({ NR: 'NR' });
                console.log(this.state.NR);
            }
            else {
                this.setState({ NR: 'R' });
                console.log(this.state.NR);
            }
        }
    }

    handleSubmit = (e) => {
        this.setState({ loading: true });

        if (this.state.PAN == '' || this.state.PAN == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "PAN is Required", "danger");
            return;
        }

        var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!regex.test(this.state.PAN)) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Invalid PAN", "danger");
            return;
        }

        if (this.state.NR === 'R' && !["P", "T", "H"].includes(this.state.PAN.substring(3, 4))) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Invalid PAN for Resident", "danger");
            return;
        }

        if (this.state.NR === 'NR' && ["P", "T", "H"].includes(this.state.PAN.substring(3, 4))) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Invalid PAN for Non-Resident", "danger");
            return;
        }

        if (this.state.EmailId == '' || this.state.EmailId == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Email is Required", "danger");
            return;
        }

        const regex1 = /^[A-Za-z\s]+$/;
        if (!regex1.test(this.state.BeneficiaryName)) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Only characters allowed", "danger");
            return;
        }

        if (this.handleFormValidation(e)) {
            //if (this.state.dob == '') {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Date of Birth is Required", "danger");
            //    return;
            //}

            //var today = new Date();
            //var birthDate = new Date(this.state.dob);

            //var age = today.getFullYear() - birthDate.getFullYear();

            //var m = today.getMonth() - birthDate.getMonth();
            //if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            //    age--;
            //}

            //if (age < 18) {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Age should be greater than 18", "danger");
            //    return;
            //}

            this.state.flag = 'I';
            this.state.IsOnlineOffline = 1;
            const demoForm15GH = this.state;
            this.setState({ loading: false });
            debugger;
            if (this.state.NR === 'NR') {
                axios.post(global.OfflineResident.SubmitOfflineNRForm15GHAPI, demoForm15GH,
                    {
                        headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.state.ShowDataPrivacy = 'N'
                            window.location.href = config.url.Web_URL + `/NonResident/FileUpload?AN=` + window.btoa(this.state.AssignmentCode) + '&EM=' + window.btoa(this.state.EmailId) + '&DP=' + window.btoa(this.state.ShowDataPrivacy) + '&NR=' + window.btoa(this.state.NR) + '&SN=' + window.btoa(this.state.BeneficiaryName) + '&DPID=' + window.btoa(this.state.DPID) + '&PAN=' + window.btoa(this.state.PAN);
                        }
                        else {
                            this.setState({ loading: false });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
            else {
                axios.post(global.OfflineResident.SubmitOfflineForm15GHAPI, demoForm15GH,
                    {
                        headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.state.IsOnlineOffline = 1;
                            window.location.href = config.url.Web_URL + "/FillManually?AC=" + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(this.state.PAN) + '&BN=' + window.btoa(this.state.BeneficiaryName);
                            this.setState({ loading: false, IsSaveDisable: false });
                        }
                        else {
                            this.setState({ loading: false });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
        else {
            this.setState({ loading: false });
            this.showNoti("Notification", global.Message.RequiredMessage, "danger");
        }
    }

    render() {
        if (this.state.loading) return <Spinner />;
        const { ResidentTypeErr, BeneficiaryErr, DOBErr, companyErr, AssignmentErr, EmailIdErr } = this.state.formErrors;

        const {
            isSearchable
        } = this.state;

        //let content = Layout.RenderNavMenu();
        //let contentFooter = Layout.RenderFooter();

        return (
            <div>
                <ReactNotification />
                {/*{content}*/}
                <div class="limiter">
                    <div class="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">
                            <div className="card m-t-20" >
                                <img src={DebenturesHubLogo} alt="Logo" className="logo-img" />
                                {/*<div class="easyDebentureLogoOffline">Debenture's Hub</div>*/}
                                <div className="card-body border-none">
                                    <h4 className="header-title text-center" style={{ texttransform: 'math-auto;' }}>You may not be able to login because login isn't activated. </h4>

                                    <Row style={{ paddingtop: "4px" }} >
                                        <h4 className="header-title" style={{ fontsize: "-7px;", texttransform: 'math-auto;' }} >To fill form, Kindly provide below details:</h4>
                                        <Col md={3}>
                                            <label className="required-field">Type:</label>
                                            <Select
                                                className="basic-single mb-3 m-t-5"
                                                classNamePrefix="Type of Beneficiary"
                                                placeholder="Type of Beneficiary"
                                                value={this.state.ResidentType.find(obj => obj.label === this.state.residentialStatus)}
                                                isSearchable={isSearchable}
                                                options={ResidentType}
                                                onChange={this.handleResidentType.bind(this)}
                                            />
                                            {ResidentTypeErr &&
                                                <div className="Mont-Font">{ResidentTypeErr}</div>
                                            }
                                        </Col>
                                        <Col md={3}>
                                            <label htmlFor="BeneficiaryName" className="required-field">Name Of Beneficiary:</label>
                                            <InputGroup className="mb-3 m-t-10">
                                                <FormControl type="text" name="BeneficiaryName" maxLength="125"
                                                    value={this.state.BeneficiaryName}
                                                    onChange={this.handleChange} autoFocus />

                                            </InputGroup>
                                            {BeneficiaryErr &&
                                                <div className="Mont-Font">{BeneficiaryErr}</div>
                                            }
                                        </Col>
                                        <Col md={3}>
                                            <label htmlFor="PAN" className="required-field">PAN No:</label>
                                            <InputGroup className="mb-3 m-t-10">
                                                <FormControl type="text" name="PAN" maxLength="10"
                                                    value={this.state.PAN}
                                                    onChange={this.handleChange}
                                                />
                                            </InputGroup>
                                        </Col>
                                        <Col md={3}>
                                            <label htmlFor="EmailId" className="required-field">Email:</label>
                                            <InputGroup className="mb-3 m-t-10">
                                                <FormControl type="text" name="EmailId" maxLength="125"
                                                    value={this.state.EmailId}
                                                    onChange={this.handleChange}
                                                    placeholder="Your email id.." />
                                            </InputGroup>
                                            {EmailIdErr &&
                                                <div style={{ color: "red", paddingBottom: 10 }}>{EmailIdErr}</div>
                                            }
                                        </Col>
                                        <Col md={3} className="m-t-8">
                                            <label htmlFor="dob">Date of Birth:</label>
                                            <InputGroup className="mb-3 m-t-10">
                                                <input type="date" name="dob"
                                                    value={this.state.dob}
                                                    className="input1001"
                                                    onChange={this.handleChange}
                                                    placeholder="DD-MMM-YYYY"
                                                    
                                                />
                                            </InputGroup>
                                           
                                        </Col>
                                        <Col md={3} className="m-t-10">
                                            <label className="required-field">Company you are enrolled in:</label>
                                            <Select
                                                className="basic-single mb-3"
                                                classNamePrefix="select Listed Company"
                                                placeholder="Select Company"
                                                value={this.state.companyList.find(obj => obj.value === this.state.RemitterID)}
                                                isSearchable={isSearchable}
                                                options={this.state.companyList}
                                                onChange={this.handleCompany.bind(this)}
                                            />
                                            {companyErr &&
                                                <div className="Mont-Font">{companyErr}</div>
                                            }
                                        </Col>
                                        <Col md={3} className="m-t-10">
                                            {/*  <label className="required-field">Schemes you are enrolled in:</label>*/}
                                            <label className="required-field">
                                                Schemes you are enrolled in:
                                                <OverlayTrigger
                                                    trigger={['hover', 'focus']}
                                                    placement="top"
                                                    overlay={
                                                        <Popover id="schemes-popover">
                                                            <Popover.Body>
                                                                You can select multiple investment schemes from the dropdown list.
                                                            </Popover.Body>
                                                        </Popover>
                                                    }
                                                >
                                                    <span
                                                        style={{
                                                            marginLeft: '5px',
                                                            color: '#007bff',
                                                            cursor: 'pointer',
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            display: 'inline-block',
                                                            width: '16px',
                                                            height: '16px',
                                                            borderRadius: '50%',
                                                            backgroundColor: '#007bff',
                                                            color: 'white',
                                                            textAlign: 'center',
                                                            lineHeight: '16px',
                                                            fontSize: '12px'
                                                        }}
                                                        title="You can select multiple schemes"
                                                    >
                                                        i
                                                    </span>
                                                </OverlayTrigger>
                                            </label>
                                            <Select
                                                className="basic-single mb-3"
                                                /*classNamePrefix="select"
                                                placeholder="Name of Schemes"*/
                                                value={this.state.AssignmentList.find(obj => obj.value === this.state.AssignmentCode)}
                                                /*{isSearchable={false}*/
                                                /*placeholderButtonLabel="Name of Schemes"*/
                                                options={this.state.AssignmentList}
                                                onChange={this.handleAssignment.bind(this)}
                                                isMulti
                                                isClearable
                                                isSearchable={true}
                                            /*hideSearch={true}*/
                                            />
                                            {AssignmentErr &&
                                                <div className="Mont-Font">{AssignmentErr}</div>
                                            }
                                        </Col>
                                        <Col md={12}>
                                            <div className="m-t-10">
                                                <button disabled={this.state.IsSaveDisable} className="btn btn-success m-l-10 pull-right m-t-15" onClick={this.handleSubmit}> Submit </button>
                                            </div>
                                        </Col>
                                        <div className="txt1 text-center p-t-20" style={{ textAlign: "center" }}>
                                            <span style={{ verticalAlign: "middle" }}>Powered by </span>
                                            <img src={NexdmsmImg} style={{ verticalAlign: "middle" }} />
                                        </div>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*{contentFooter}*/}
            </div>
        );
    }
}